module.exports = __webpack_public_path__ + "img/calendar.f6c56a1b.svg";